import React from "react"

const NavItem = ({ className, ariacontrols}) => {
  className = `navbar-toggler${className ? ` ${className} ` : ''}`
  
  return <button className={className} type="button" data-bs-toggle="collapse" data-bs-target={`#${ariacontrols}`} aria-controls={ariacontrols} aria-expanded="false" aria-label="Toggle navigation">
  <span className="navbar-toggler-icon"></span></button>
}
export default NavItem
